<template>
  <div class="index">
    <div class="index-top">
      <div class="w">
        <img class="index-logo" src="../../static/logo.png" alt="">
        <p class="top-title">2021智能技术人才招聘专场</p>
        <p class="top-subtitle">机器人、人工智能、自动/无人驾驶等领域</p>
        <div class="top-desc">
          <span>
            <i class="iconfont icon-zuobiao"></i>
            一线名企内推</span>
          <span>
            <i class="iconfont icon-hxbj"></i>
            核心优质岗位</span>
          <span>
            <i class="iconfont icon-zncg"></i>
            24小时极速反馈</span>
        </div>
        <img src="../../static/banner_img.png" alt="">
      </div>
    </div>
    <div class="index-componys">
      <div class="w">
        <div class="index-title">
          <div class="p-only">
            <span>业界翘楚，悉数在列；</span>
            <span>招贤纳士，机遇难求</span>
          </div>
          <div class="m-only">
            <p>业界翘楚，悉数在列</p>
            <p>招贤纳士，机遇难求</p>
          </div>
        </div>
        <p class="index-desc">业内星级雇主，真实、靠谱、福利好</p>
        <ul class="list">
          <li @click="$router.push(`/compony/${componyIndex}`)" @mouseover="currentCompony = componyIndex" :class="currentCompony === componyIndex ? 'act' : ''" v-for="(compony, componyIndex) in getHotCompony" :key="componyIndex">
            <img :src="compony.img ? `${publicPath}images/${ compony.name }-w.jpg` : `${publicPath}images/logo-default.png`" alt="">
          </li>
        </ul>
        <div class="swiper">
          <swiper :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide v-for="(compony, componyIndex) in getHotCompony" :key="componyIndex">
              <div @click="$router.push(`/compony/${componyIndex}`)" class="info">
                <img :src="compony.img ? `${publicPath}images/${ compony.name }.jpg` : `${publicPath}images/logo-default.png`" alt="">
                <p class="title">{{ compony.name }}</p>
                <p class="desc">{{ compony.field }}</p>
                <p class="base">
                  <span class="text-overflow"><i class="iconfont icon-zuobiao-on"></i>{{ compony.city }}</span>
                  <span>{{ compony.scale }}</span>
                </p>
              </div>
              <ul class="tags">
                <li v-for="(tag, tagIndex) in compony.tags" :key="tagIndex">{{ tag }}</li>
              </ul>
              <ul class="offices">
                <template v-for="(jd, jdIndex) in compony.jds">
                  <li v-if="jdIndex < 3" :key="jdIndex" @click="$router.push(`/claim/${componyIndex}/${jdIndex}`)">
                    <span>{{ jd.name }}</span>
                    <span class="salary">{{ jd.salary }}</span>
                  </li>
                </template>
              </ul>
              <router-link class="more" :to="`/compony/${componyIndex}`">查看更多 <i class="iconfont icon-youjiantou"></i></router-link>
              <router-link class="m-more" :to="`/compony/${componyIndex}`">更多</router-link>
            </swiper-slide>
            <div class="swiper-pagination"  slot="pagination"></div>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev">
            <i class="iconfont icon-zuojiantou"></i>
          </div>
          <div class="swiper-button-next" slot="button-next">
            <i class="iconfont icon-youjiantou"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="index-hot">
      <div class="w">
        <p class="index-title">高薪职位，正在热招</p>
        <p class="index-desc">100+热门岗位总有一个适合你</p>
        <ul class="list">
          <li v-for="(compony, componyIndex) in componys" :key="componyIndex">
            <div @click="$router.push(`/compony/${componyIndex}`)" class="item-top">
              <div class="item-img">
                <img :src="compony.img ? `${publicPath}images/${ compony.name }.jpg` : `${publicPath}images/logo-default.png`" alt="">
              </div>
              <div class="item-info">
                <p class="info-title">{{ compony.name }}</p>
                <p class="info-desc text-overflow">{{ compony.field }}</p>
                <p class="info-base">
                  <span class="text-overflow">
                    <i class="iconfont icon-zuobiao-on"></i> {{ compony.city }}
                  </span>
                  <span>{{ compony.scale }}</span>
                </p>
              </div>
            </div>
            <ul class="offices">
              <template v-for="(jd, jdIndex) in compony.jds">
                <li v-if="jdIndex < 3" :key="jdIndex" @click="$router.push(`/claim/${componyIndex}/${jdIndex}`)">
                  <span class="text-overflow">{{ jd.name }}</span>
                  <span class="salary">{{ jd.salary }}</span>
                </li>
              </template>
            </ul>
            <router-link class="more" :to="`/compony/${componyIndex}`">更多高薪职位</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="index-examples">
      <div class="w">
        <p class="index-title">入职案例, 真实评论</p>
        <p class="index-desc">用心为你规划更好的前途和“钱”途</p>
        <div class="pc">
          <img src="../../static/comment.jpg" >
        </div>
        <div class="mobile">
          <img src="../../static/comment-m.png" >
        </div>
      </div>
    </div>
    <div class="index-contact">
      <div class="w">
        <div class="wechat">
          <img src="../../static/contact-tony.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componys from '@/data.js'
import vxShare from '@/util/vxShare.js'

export default {
  data () {
    return {
      swiperOption: {
        effect : 'coverflow',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          transitionEnd: () => {
            this.currentCompony = this.swiper.realIndex
          }
        },
        autoplay: true
      },
      currentCompony: 0,
      componys: componys
    }
  },
  mounted () {
    vxShare()
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    getHotCompony () {
      return this.componys.slice(0, 8)
    }
  },
  watch: {
    currentCompony () {
      this.swiper.slideTo(this.currentCompony, 1000, false)
    }
  }
}
</script>

<style lang="scss" scoped>
.index{
  .index-title{
    color: #5730f1;
    font-size: 36px;
    line-height: 46px;
    margin-bottom: 8px;
    text-align: center;
    font-weight: 700;
  }
  .index-desc{
    font-size: 16px;
    line-height: 20px;
    color: #92969C;
    text-align: center;
  }
  .index-top{
    height: 358px;
    background-color: #5730f1;
    background-image: url('../../static/index-top.png'), linear-gradient(to bottom, rgb(48, 134, 241), rgb(0, 82, 184));
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    .w{
      position: relative;
      height: 100%;
      .top-m-nav{
        display: none;
      }
      .top-nav{
        left: 0;
        top: 50px;
        opacity: .75;
        color: #fff;
        font-size: 18px;
        line-height: 18px;
        text-decoration: none;
        position: absolute;
        transform: translateX(0)
      }
      .top-title{
        margin: 0;
        padding-top: 110px;
        line-height: 70px;
        font-size: 45px;
        font-weight: 700;
        color: white;
        text-shadow:rgba($color: #000000, $alpha: .16) 0px 4px 1px;
      }
      .top-subtitle{
        margin: 5px 0 40px 0;
        font-size: 26px;
        color: #ffffff;
      }
      .top-desc{
        font-size: 18px;
        line-height: 26px;
        color: white;
        span{
          margin-right: 30px;
          .iconfont{
            font-size: 26px;
            vertical-align: -3px;
          }
        }
      }
      img{
        position: absolute;
        width: 530px;
        height: 350px;
        bottom: -41px;
        right: 38px;
      }
      .index-logo{
        position: absolute;
        left: 0;
        top: 58px;
        width: 156px;
        height: auto;
      }
    }
  }
  .index-componys{
    margin-top: 70px;
    .list{
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding: 0;
      margin-top: 40px;
      li{
        margin-right: 20px;
        margin-bottom: 20px;
        border: 1px solid #D1D1D1;
        width: 260px;
        height: 90px;
        line-height: 90px;
        text-align: center;
        box-sizing: border-box;
        transition: all .3s;
        cursor: pointer;
        opacity: .5;
        transform: translateY(0px);
        overflow: hidden;
        img{
          max-width: 100%;
          max-height: 100%;
        }
        &.extend{
          visibility: hidden;
          height: 0;
        }
        &:nth-child(4n){
          margin-right: 0;
        }
        &:nth-last-child(1){
          margin-right: 0;
        }
        &.act {
          border-color: #5730f1;
          opacity: 1;
          box-shadow: -1px -1px 15px 0px rgba($color: #5730f1, $alpha: .75);
          transform: translateY(-1.5px);
        }
      }
    }
    .swiper{
      width: 1200px;
      margin: 0 auto;
      position: relative;
      .swiper-container{
        padding-top: 40px;
        padding-bottom: 45px;
        margin-left: 75px;
        margin-right: 75px;
        .swiper-slide{
          width: 1050px;
          height: 240px;
          background-color: #5730f1;
          background-image: url('../../static/index-swiper.png'), linear-gradient(to bottom, rgb(48, 134, 241), rgb(0, 82, 184));
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          position: relative;
          border-radius: 20px;
          padding: 0px 50px;
          box-sizing: border-box;
          color: white;
          position: relative;
          .info{
            height: 112px;
            position: relative;
            box-sizing: border-box;
            padding-top: 27px;
            cursor: pointer;
            img{
              width: 140px;
              height: 140px;
              border-radius: 14px;
              border: 1px solid #E7E7E7;
              top: -28px;
              position: absolute;
              left: 0;
              box-sizing: border-box;
              background: #fff;
            }
            .title{
              padding-left: 160px;
              font-size: 24px;
              line-height: 30px;
              font-weight: 700;
              margin-bottom: 6px;
            }
            .desc{
              padding-left: 160px;
              font-size: 16px;
              line-height: 20px;
              margin-bottom: 13px;
              color: #CFE4FF;
            }
            .base{
              padding-left: 160px;
              font-size: 13px;
              color: #CFE4FF;
              opacity: .75;
              .iconfont{
                font-size: 13px;
              }
              span{
                margin-right: 7.5px;
                display: inline-block;
                height: 13px;
                &:nth-child(2n) {
                  padding-left: 7.5px;
                  border-left: 1px solid #CFE4FF;
                }
              }
            }
          }
          .tags{
            margin-top: 33px;
            display: flex;
            justify-content: flex-start;
            height: 30px;
            overflow: hidden;
            flex-wrap: wrap;
            & > li{
              background: #FFFFFF;
              color: #5730f1;
              line-height: 25px;
              font-size: 13px;
              border-radius: 30px;
              margin-right: 10px;
              text-align: center;
              margin-bottom: 10px;
              height: 25px;
              padding: 0 13px;
            }
          }
          .offices{
            margin-top: 25px;
            display: flex;
            justify-content: flex-start;
            & > li{
              cursor: pointer;
              font-size: 16px;
              margin-right: 30px;
              border-right: 2px solid rgba($color: #fff, $alpha: .5);
              width: auto;
              white-space: nowrap;
              height: 16px;
              span{
                &:nth-last-child(1) {
                  padding-right: 30px;
                }
              }
              &:nth-last-child(1) {
                border: none;
              }
              .salary{
                margin-left: 12px;
                display: inline-block;
                color: #FF8330;
              }
            }
          }
          .more{
            width: 143px;
            height: 49px;
            background-color: #fff;
            border: 1px solid #5730f1;
            line-height: 49px;
            text-align: center;
            font-size: 16px;
            color: #5730f1;
            position: absolute;
            top: 50px;
            right: 50px;
            text-decoration: none;
            border-radius: 30px;
            font-weight: 700;
          }
          .m-more{
            display: none;
          }
        }
      }
      .swiper-button-prev{
        position: absolute;
        left: 0px;
        top: 165px;
        transform: translateY(-50%);
        margin: 0;
        padding: 0;
        background: none;
        -webkit-tap-highlight-color:rgba(0,0,0,0);
        outline: none;
        .iconfont{
          font-size: 36px;
          color: #D4D4D4;
        }
      }
      .swiper-button-next{
        position: absolute;
        right: 0px;
        top: 165px;
        transform: translateY(-50%);
        margin: 0;
        padding: 0;
        background: none;
        -webkit-tap-highlight-color:rgba(0,0,0,0);
        outline: none;
        .iconfont{
          font-size: 36px;
          color: #D4D4D4;
        }
      }
    }
  }
  .index-hot{
    background-color: #F4F4F6;
    padding-bottom: 40px;
    .index-title{
      padding-top: 40px;
    }
    .list{
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding: 0;
      margin-top: 40px;
      & > li{
        background-color: #fff;
        width: 384px;
        height: 310px;
        margin-right: 15px;
        margin-bottom: 15px;
        box-sizing: border-box;
        box-shadow: rgba($color: #000000, $alpha: .05) 0px 3px 6px 0px;
        padding: 15px;
        border-radius: 5px;
        .item-top{
          width: 100%;
          height: 120px;
          display: flex;
          justify-content: flex-start;
          cursor: pointer;
          .item-img{
            flex-shrink: 0;
            width: 120px;
            height: 120px;
            border: 1px solid #E6E6E6;
            border-radius: 4px;
            line-height: 120px;
            text-align: center;
            overflow: hidden;
            background-image: url('../../static/logo-default.png');
            background-size: cover;
            img{
              width: 100%;
              height: auto;
              vertical-align: top;
            }
          }
          .item-info{
            width: 200px;
            padding-left: 15px;
            .info-title{
              padding-top: 15px;
              line-height: 25px;
              font-size: 20px;
              color: #000000;
              margin-bottom: 7px;
              font-weight: 700;
            }
            .info-desc{
              font-size: 14px;
              line-height: 18px;
              height: 18px;
              overflow: hidden;
              color: #9A9A9A;
              margin-bottom: 22px;
            }
            .info-base{
              color: #9A9A9A;
              font-size: 12px;
              display: flex;
              justify-content: space-between;
              .iconfont{
                font-size: 12px;
              }
              span{
                &:nth-child(2) {
                  flex-shrink: 0;
                }
              }
            }
          }
        }
        .offices{
          height: 120px;
          padding-top: 6px;
          box-sizing: border-box;
          list-style: none;
          & > li{
            display: flex;
            justify-content: space-between;
            padding: 0 12px;
            line-height: 36px;
            font-size: 14px;
            color: #000000;
            height: 36px;
            overflow: hidden;
            box-sizing: border-box;
            border-top: 1px solid transparent;
            border-bottom: 1px solid transparent;
            cursor: pointer;
            &:nth-child(2n){
              border-top: 1px solid #F1F1F1;
              border-bottom: 1px solid #F1F1F1;
            }
            &:hover{
              background-color: #F9F9F9;
            }
            .salary{
              font-weight: 700;
              color: #5730f1;
              flex-shrink: 0;
            }
          }
        }
        .more{
          border-radius: 5px;
          background-color: #5730f1;
          color: white;
          font-weight: 700;
          height: 40px;
          width: 100%;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          display: block;
          text-decoration: none;
        }
        &:nth-child(3n) {
          margin-right: 0;
        }
        &:nth-last-child(1) {
          margin-right: 0;
        }
      }
    }
  }
  .index-examples{
    margin-top: 80px;
    text-align: center;
    .mobile{
      display: none;
    }
  }
  .index-contact{
    padding: 30px 0;
    text-align: center;
  }
}

@media (max-width: 768px){
  .w{
    width: auto;
  }
  .index{
    .index-title{
      font-size: 24px;
      line-height: 30px;
      margin-bottom: 8px;
    }
    .index-desc{
      font-size: 13px;
      line-height: 16px;
    }
    .index-top{
      height: auto;
      background-color: #5730f1;
      position: relative;
      .w{
        position: relative;
        height: 100%;
        padding-top: 65px;
        padding-bottom: 40px;
        padding-left: 25px;
        box-sizing: border-box;
        .top-m-nav{
          display: block;
          position: absolute;
          color: #fff;
          opacity: .75;
          font-size: 14px;
          left: 20px;
          top: 23px;
          text-decoration: none;
        }
        .top-nav{
          display: none;
        }
        .top-title{
          margin: 0;
          line-height: 40px;
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 17px;
          padding-top: 0;
        }
        .top-desc{
          font-size: 13px;
          line-height: 24px;
          color: white;
          span{
            display: block;
            margin-right: 0;
            .iconfont{
              font-size: 14px;
              vertical-align: -1px;
            }
          }
        }
        img{
          position: absolute;
          width: 45%;
          height: auto;
          bottom: -16px;
          right: 25px;
        }
        .index-logo{
          position: absolute;
          left: 28px;
          top: 20px;
          width: 30%;
          height: auto;
        }
      }
    }
    .index-componys{
      margin-top: 40px;
      .list{
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        padding: 14px;
        li{
          margin: 0;
          width: 24%;
          height: auto;
          line-height: 1;
          margin-bottom: 10px;
          img{
            vertical-align: top;
          }
          &.act {
            border-color: #5730f1;
          }
        }
      }
      .swiper{
        padding: 0 14px;
        box-sizing: border-box;
        width: 100%;
        position: relative;
        .swiper-container{
          margin: 0;
          padding-top: 30px;
          padding-bottom: 50px;
          .swiper-slide{
            width: 100%;
            height: auto;
            background-color: #5730f1;
            border-radius: 20px;
            padding: 0px 20px;
            padding-bottom: 6px;
            box-sizing: border-box;
            color: white;
            position: relative;
            .info{
              height: 107px;
              position: relative;
              box-sizing: border-box;
              padding-top: 20px;
              img{
                width: 90px;
                height: 90px;
                border-radius: 4px;
                border: 1px solid #E7E7E7;
                top: -30px;
                position: absolute;
                left: 0;
                box-sizing: border-box;
                background: #fff;
              }
              .title{
                padding-left: 102px;
                font-size: 20px;
                line-height: 24px;
                font-weight: 700;
                margin-bottom: 5px;
                height: 24px;
                padding-right: 15px;
                overflow: hidden;
              }
              .desc{
                padding-left: 102px;
                font-size: 14px;
                line-height: 18px;
                height: 18px;
                overflow: hidden;
                margin-bottom: 7px;
                color: #CFE4FF;
              }
              .base{
                padding-left: 102px;
                font-size: 12px;
                color: #CFE4FF;
                line-height: 13px;
                display: flex;
                .iconfont{
                  font-size: 13px;
                }
                span{
                  line-height: 13px;
                  height: 13px;
                  display: inline-block;
                  &:nth-child(2) {
                    flex-shrink: 0;
                  }
                }
              }
            }
            .tags{
              margin: 0;
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              max-height: 60px;
              overflow: hidden;
              & > li{
                background: #FFFFFF;
                color: #5730f1;
                line-height: 22px;
                font-size: 12px;
                border-radius: 30px;
                margin-right: 8px;
                margin-bottom: 8px;
                text-align: center;
                height: 22px;
                padding: 0 12px;
              }
            }
            .offices{
              margin-top: 10px;
              border-top: 1px solid #FFFFFF;
              display: block;
              padding-top: 10px;
              & > li{
                font-size: 14px;
                line-height: 14px;
                margin-bottom: 10px;
                width: 100%;
                border: none;
                display: flex;
                justify-content: space-between;
                span.salary{
                  font-weight: 700;
                  margin-left: 0;
                  padding-right: 0px;
                }
              }
            }
            .more{
              display: none;
            }
            .m-more{
              position: absolute;
              display: block;
              width: 40px;
              height: 23px;
              right: 0;
              top: 22px;
              line-height: 23px;
              font-size: 13px;
              font-weight: 700;
              color: #5730f1;
              border-top-left-radius: 30px;
              border-bottom-left-radius: 30px;
              background: #fff;
              text-align: center;
              text-decoration: none;
            }
          }
        }
        .swiper-button-prev{
          display: none;
        }
        .swiper-button-next{
          display: none;
        }
      }
    }
    .index-hot{
      background-color: #F4F4F6;
      padding-bottom: 20px;
      .index-title{
        padding-top: 30px;
      }
      .list{
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 0 20px;
        margin-top: 22px;
        & > li{
          background-color: #fff;
          width: 100%;
          height: auto;
          margin-right: 0;
          box-sizing: border-box;
          box-shadow: rgba($color: #000000, $alpha: .05) 0px 3px 6px 0px;
          padding: 12px;
          border-radius: 5px;
          margin-bottom: 15px;
          .item-top{
            width: 100%;
            height: 75px;
            display: block;
            position: relative;
            .item-img{
              width: 75px;
              height: 75px;
              border: 1px solid #E6E6E6;
              border-radius: 4px;
              line-height: 75px;
              text-align: center;
              position: absolute;
              left: 0px;
              top: 0px;
              img{
                width: 100%;
                height: auto;
                vertical-align: middle;
              }
            }
            .item-info{
              width: auto;
              padding-left: 87px;
              .info-title{
                padding-top: 4px;
                line-height: 20px;
                font-size: 16px;
                color: #000000;
                margin-bottom: 5px;
                font-weight: 700;
              }
              .info-desc{
                font-size: 13px;
                line-height: 16px;
                height: 16px;
                overflow: hidden;
                color: #9A9A9A;
                margin-bottom: 11px;
                white-space: pre-wrap;
              }
              .info-base{
                color: #9A9A9A;
                font-size: 12px;
                display: flex;
                justify-content: flex-start;
                span{
                  height: 12px;
                  overflow: hidden;
                  margin-right: 7.5px;
                  position: relative;
                  &:nth-child(2n) {
                    padding-left: 7.5px;
                    border-left: 1px solid #9A9A9A;
                  }
                }
                .iconfont{
                  font-size: 12px;
                }
              }
            }
          }
          .offices{
            height: 89px;
            padding-top: 8.5px;
            padding-bottom: 8.5px;
            box-sizing: border-box;
            list-style: none;
            overflow: hidden;
            & > li{
              display: flex;
              justify-content: space-between;
              padding: 0 12px;
              line-height: 36px;
              font-size: 14px;
              color: #000000;
              height: 36px;
              overflow: hidden;
              box-sizing: border-box;
              border-top: 1px solid transparent;
              border-bottom: 1px solid transparent;
              &:nth-child(2n){
                border-top: 1px solid #F1F1F1;
                border-bottom: 1px solid transparent;
                background-color: transparent;
              }
              .salary{
                font-weight: 700;
                color: #5730f1;
                margin-left: 0;
                flex-shrink: 0;
              }
            }
          }
          .more{
            border-radius: 5px;
            background-color: #5730f1;
            color: white;
            font-weight: 700;
            height: 42px;
            width: 100%;
            text-align: center;
            line-height: 42px;
            font-size: 16px;
            display: block;
            text-decoration: none;
          }
          &:nth-child(3n) {
            margin-right: 0;
          }
          &:nth-last-child(1) {
            margin-right: 0;
          }
        }
      }
    }
    .index-examples{
      margin-top: 40px;
      .pc{
        display: none;
      }
      .mobile{
        display: block;
        img{
          width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.index{
  .index-componys{
    .swiper{
      .swiper-container{
        .swiper-pagination{
          bottom: 18px;
          .swiper-pagination-bullet{
            height: 10px;
            width: 10px;
            background-color: #D2D2D2;
            border-radius: 5px;
            opacity: 1;
            transition: all .3s;
            outline: none;
            &.swiper-pagination-bullet-active{
              background-color: #5730f1;
              width: 24px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px){
  .index{
    .index-top{
      .w{
        .top-subtitle{
          font-size: 18px!important;
        }
      }
    }
    .index-componys{
      .swiper{
        .swiper-container{
          .swiper-pagination{
            bottom: 20px;
            .swiper-pagination-bullet{
              height: 10px;
              width: 10px;
              background-color: #D2D2D2;
              border-radius: 5px;
              opacity: 1;
              transition: all .3s;
              &.swiper-pagination-bullet-active{
                background-color: #5730f1;
                width: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
